import { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";

export default function C_E_TIME({
  tempValue,
  onChange,
  onBlur,
  onKeyDown,
  inPopup = false,
}) {
  const properties_state = useSelector((state) => state.properties);

  const inputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (!inPopup && inputRef.current) {
      inputRef.current.focus();
    }
  }, [inPopup]);

  const handleBlur = (e) => {
    setIsFocused(false);
    if (onBlur) onBlur(e);
  };

  // 1. POPUP MODE
  if (inPopup) {
    const mode_map = properties_state.mode_map; //editor || viewer

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column", // Ensures the helper text stacks below the input
          width: "100%",
          boxSizing: "border-box",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <input
          disabled={mode_map !== "editor"}
          ref={inputRef}
          type="time"
          value={tempValue || ""}
          onChange={onChange}
          onBlur={handleBlur}
          onFocus={() => setIsFocused(true)}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => {
            // Pass Enter and Escape up to close the cell/save the data
            if (e.key === "Enter" || e.key === "Escape") {
              // Force the input to lose focus so the helper text disappears
              if (inputRef.current) {
                inputRef.current.blur();
              }
              if (onKeyDown) onKeyDown(e);
            }
            // In popup mode, we don't need to stop propagation for arrow keys
          }}
          className="input"
          style={{ width: "100%", boxSizing: "border-box" }}
        />
        {isFocused && (
          <p
            className="text_small"
            style={{ margin: "4px 0 0 0", color: "#666" }}
          >
            Press Enter to save
          </p>
        )}
      </div>
    );
  }

  // 2. TABLE EDIT MODE
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        height: "100%",
        alignItems: "center",
        backgroundColor: "#dedede",
        padding: "0 8px",
        boxSizing: "border-box",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <input
        ref={inputRef}
        type="time"
        value={tempValue || ""}
        onChange={onChange}
        onBlur={handleBlur}
        onFocus={() => setIsFocused(true)}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === "Escape") {
            if (inputRef.current) {
              inputRef.current.blur();
            }
            if (onKeyDown) onKeyDown(e);
          } else {
            // Stop propagation for all other keys (Arrow keys) so the user
            // can navigate inside the native time popup safely without moving table cells.
            e.stopPropagation();
          }
        }}
        className="input_table"
        style={{ width: "100%", boxSizing: "border-box" }}
      />
    </div>
  );
}
